/**
 * @file Service pour la gestion des notifications.
 * @description
 * Ce service permet aux utilisateurs de récupérer leurs notifications
 * non lues pour leur organisation. Les notifications sont liées à
 * l'organisation de l'utilisateur connecté.
 */
import { apiService } from "./api.service";
import { NOTIFICATIONS } from "../config/api.endpoints";
import type { ApiComponents } from "@/types/api";

type NotificationResponse = ApiComponents["schemas"]["NotificationResponse"];

export const NotificationsService = {
  /**
   * Récupère toutes les notifications non lues pour l'organisation de l'utilisateur
   */
  async getMyNotifications(): Promise<NotificationResponse[]> {
    return apiService.get<NotificationResponse[]>(NOTIFICATIONS.LIST);
  },

  /**
   * Marque une notification comme lue (si l'API le supporte à l'avenir)
   * Pour l'instant, cette méthode est préparée pour une future implémentation
   */
  async markAsRead(notificationId: string): Promise<void> {
    // Placeholder until backend endpoint for individual read status is available.
    console.warn(
      `markAsRead not yet implemented for notification ${notificationId}`
    );
  },

  /**
   * Marque toutes les notifications comme lues (si l'API le supporte à l'avenir)
   * Pour l'instant, cette méthode est préparée pour une future implémentation
   */
  async markAllAsRead(): Promise<void> {
    // Placeholder until backend bulk read endpoint is available.
    // return apiService.patch(NOTIFICATIONS.MARK_ALL_READ, {});
    console.warn(
      "markAllAsRead not yet implemented - waiting for backend API support"
    );
  },

  /**
   * Supprime une notification (si l'API le supporte à l'avenir)
   * Pour l'instant, cette méthode est préparée pour une future implémentation
   */
  async deleteNotification(notificationId: string): Promise<void> {
    // Placeholder until backend delete endpoint is available.
    console.warn(
      `deleteNotification not yet implemented for notification ${notificationId}`
    );
  },
};

export default NotificationsService;
